export default (value: string | null) => {
  if (!value || !Number.isInteger(Number(value))) {
    return "Value must be a whole number"
  }
  return true
}
